import { all } from 'typed-redux-saga'

import watchEligibility from './eligibility/saga'
import watchProposal from './proposal/saga'

export default function* rootSaga() {
  return yield* all([watchEligibility(), watchProposal()])
}
